var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 9.16683C7.29232 9.16683 9.16732 7.29183 9.16732 5.00016C9.16732 2.7085 7.29232 0.833496 5.00065 0.833496C2.70898 0.833496 0.833984 2.7085 0.833984 5.00016C0.833984 7.29183 2.70898 9.16683 5.00065 9.16683Z",
    stroke: "#F4694C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.3335V5.41683",
    stroke: "#F4694C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99805 6.6665H5.00179",
    stroke: "#F4694C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleOutline);
export default __webpack_public_path__ + "static/media/info-circle-outline.feeb809558c83a7bf1cd270798f07aa9.svg";
export { ForwardRef as ReactComponent };